




















import { defineComponent, onBeforeMount, reactive } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import SearchInput from '@/components/organisms/questionnaire-answer/SearchInput.vue'
import QuestionnaireAnswerTable from '@/components/organisms/questionnaire-answer/QuestionnaireAnswerTable.vue'
import useVuex from '@/utils/useVuex'
import {
  QuestionnaireAnswerState,
  QuestionnaireState,
  UserState,
} from '@/types/store'
import { UserRole } from '@/types/user'
import { GetQuestionnaireQuery } from '@/types/questionnaire'
import { Methods } from 'api/questionnaire-answer'

export default defineComponent({
  name: 'AdminManualQuestionnaireAnswer',
  components: { Layout, SearchInput, QuestionnaireAnswerTable },
  setup(props, context) {
    const store = context.root.$store
    const questionnaireId =
      typeof context.root.$route.query.id === 'string'
        ? parseInt(context.root.$route.query.id)
        : undefined
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      questionnaireAnswers: useVuex<
        QuestionnaireAnswerState['questionnaireAnswers']
      >(
        context,
        () => store.getters['questionnaireAnswer/questionnaireAnswers'],
      ),

      isQuestionnaireAnswerLoading: useVuex<
        QuestionnaireAnswerState['isQuestionnaireAnswerLoading']
      >(
        context,
        () => store.getters['questionnaireAnswer/isQuestionnaireAnswerLoading'],
      ),

      completions: useVuex<QuestionnaireState['completeQuestionnaires']>(
        context,
        () => store.getters['questionnaire/completions'],
      ),
    })

    const reset = () => {
      const query: NonNullable<Methods['get']['query']> = {
        dummy: '',
        isAutomatic: false,
      }
      if (questionnaireId && !isNaN(questionnaireId)) {
        query.questionnaireId = questionnaireId
      }
      if (state.user?.role === UserRole.LEADER) {
        query.checkerCheckStatus = 'ng'
      }
      store.dispatch('questionnaireAnswer/getQuestionnaireAnswers', query)
    }

    onBeforeMount(() => {
      store.dispatch('questionnaire/getCompleteQuestionnaires', {
        isAutomatic: false,
      })
    })

    const search = (query: GetQuestionnaireQuery) => {
      store.dispatch('questionnaireAnswer/getQuestionnaireAnswers', {
        ...query,
        dummy: '',
        isAutomatic: false,
      })
    }

    return { state, questionnaireId, search, reset }
  },
})
